import React, { Component } from 'react'
import { connect } from 'react-redux'
import { sectionEmailStudentStudentCodes,syncSectionWithIntegration } from '../../actions/sections'
import { upsertIntegration } from '../../actions/integrations'
import Button from '../../components/uiKit/Button'
import SectionMarker from '../../components/uiKit/SectionMarker'
import FeatureModalSelectControl from '../../components/featureModals/FeatureModalSelectControl'
import { showNotification } from '../../actions/notifications'
import filter from 'lodash/filter'
const SCOPES = "https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.courses.readonly"
//const ADDITIONALSCOPES = "https://www.googleapis.com/auth/classroom.profile.emails"
const ALLSCOPES= "https://www.googleapis.com/auth/classroom.profile.emails https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.profile.emails"
const CLOSE_MODAL_DELAY=1000

class DistributeStudentCodesGCModal extends Component {
	
	constructor(){
		super()				
		this.handleBackgroundClick=this.handleBackgroundClick.bind(this)
		this.shareStudentCodes=this.shareStudentCodes.bind(this)
		this.handleClickCancel=this.handleClickCancel.bind(this)		
		this.state=({
			submitLoading:false,
			announcementMessage:"",
			ccUser:false
		})
	}

	componentDidMount() {
		if(window.analytics){
			 window.analytics.page('GC share student codes modal')
		}
	}

 	UNSAFE_componentWillMount() {
		document.body.style.overflowY='hidden' //prevent scrolling while modal is open
	}

	componentWillUnmount() {
		document.body.style.overflowY='' // overlay is not supported by firefox, so default to blank (auto style comes from css)
		document.body.style.overflowY='overlay' // overlay is to prevent windows scrollbars interacting with pagewidth
	}

	handleBackgroundClick(e){
		if (!this.state.submitLoading && e.target === e.currentTarget) {
			if(window.analytics){
				window.analytics.track('GC share student codes modal action',{
					 action:'dismiss',
					 isElearningActivationFlow:this.props.isElearningActivationFlow
					})
			}
			this.props.dismissModal() //close modal is click outside modal
		}
	}
	

	handleClickCancel(e){
		e.stopPropagation()
		if(window.analytics){
			window.analytics.track('GC share student codes modal action',{
				 action:'cancel',
				 isElearningActivationFlow:this.props.isElearningActivationFlow,
				})
		}
		this.props.dismissModal()
	}

	
	addEmailScope(){
		let params = {
			client_id:process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID,
			scope:SCOPES,
			prompt:'consent',
			responseType:'code',
			accessType:'offline',
		}	   	
   	window.gapi.load('auth2', () => {
    	const GoogleAuth = window.gapi.auth2.getAuthInstance()
    	if(!GoogleAuth){
    	 	window.gapi.auth2.init(params).then(
					res => {			
					res.grantOfflineAccess({scope:ALLSCOPES,login_hint:this.props.sectionIntegrationRosterEmail}).then(
						res2 => {
							const requestBody={
					'type':'googleClassroom',
					'authCode':res2.code
				}
				this.props.upsertIntegration(requestBody).then(()=>{
					this.shareStudentCodes()
				})
			})
			})
    	}else{
    		GoogleAuth.grantOfflineAccess({scope:ALLSCOPES,login_hint:this.props.sectionIntegrationRosterEmail}).then(
       		res =>{
						const requestBody={
							'type':'googleClassroom',
							'authCode':res.code
						}
						this.props.upsertIntegration(requestBody).then(()=>{
							this.shareStudentCodes()
						})
       		})
    	 	} 
      })
		}

  	shareStudentCodes(){
  		this.setState({submitLoading:true})
  		const requestData={
  			message:this.state.announcementMessage,
  			ccUser:this.state.ccUser

  		}
  		if(window.analytics){
				window.analytics.track('GC share student codes modal action',{
				 action:'send',
				 isElearningActivationFlow:this.props.isElearningActivationFlow,
				})
			}
  		//first sync section 
			this.props.syncSectionWithIntegration(this.props.section.id).then(()=>{
				this.props.sectionEmailStudentStudentCodes(this.props.section.id,requestData).then(()=>{  		
					setTimeout(function() {
						this.props.dismissModal()
						this.props.showNotification("Your students should receive them immediately.","E-Learning links emailed!",'create')
						this.props.onSendCodesSuccess()
						if(window.analytics){
							window.analytics.track('GC share student codes success',{
								studentCount:this.props.section.students.length,
								customMessage:this.state.announcementMessage?true:false,
								customMessageText:this.state.announcementMessage,
								isElearningActivationFlow:this.props.isElearningActivationFlow,
								ccUser:this.state.ccUser
							})
						}
					}.bind(this), CLOSE_MODAL_DELAY)
				})
				.catch(err => {
					this.addEmailScope()
				})
			})
			.catch(err => {
				this.addEmailScope()
			})
  	}




	
	render() {
		const readyToSubmit=true	
		const studentCount = filter(this.props.section.students,{archived:false}).length
		let studentCountLabel
		if(studentCount === 1){
			studentCountLabel = 'One Student'			
		}
		else{
			studentCountLabel = `${studentCount} Students`
		}
		return (
			<div className='distributeStudentCodesGCModalContainer' onClick={this.handleBackgroundClick}>				
				<div className='distributeStudentCodesGCModal'>					
					<div className='distributeStudentCodesGCModal-sectionLabel'>
						<SectionMarker section={this.props.section} />
					</div>
					<div className='distributeStudentCodesGCModal-header'>
						Email Setup Links to Students with Google Classroom
					</div>
					<div className='distributeStudentCodesGCModal-description'>
						<div className='distributeStudentCodesGCModal-description-p'>
							No need to share a link every time you play. Plickers uses a unique E-Learning registration link for each student that registers their device (like a Chromebook or iPad) to Plickers.
						</div>
						<div className='distributeStudentCodesGCModal-description-p'>								
							After clicking their registration link, your students can visit <emph>my.plickers.com</emph> on their device to answer live – no accounts, passwords, or daily links.
						</div>
						<div className='distributeStudentCodesGCModal-description-p'>								
							<emph>Send your students a one-time email to their Google Classroom email address from Plickers containing their link.</emph> Plickers does not store or save student email addresses, and we will sync your Google Classroom roster before sending emails
						</div>

					</div>
					<div className='distributeStudentCodesGCModal-customMessage'>
						<div className='distributeStudentCodesGCModal-customMessage-title'>
							 Add Message
						</div>					
						<textarea	      
							className='distributeStudentCodesGCModal-customMessage-textArea'
							value={this.state.announcementMessage}		      
							onChange={(e)=>{this.setState({announcementMessage:e.target.value})}}							
							maxLength={350}
							placeholder='Add a custom message to the student link emails. Tip: Your message will appear below their link and instructions.'
						/>

					</div>


					<div className='distributeStudentCodesGCModal-CCcheckboxContainer'>
						<FeatureModalSelectControl								
							checkbox
							checked={this.state.ccUser}													
							onClick={()=>{this.setState({ccUser:!this.state.ccUser})}}
							label={`Add yourself as CC (${this.props.sectionIntegrationRosterEmail})`}
							subLabel={studentCount > 9 ? `Note: you will receive ${studentCount} emails` : ''}
						/>
					</div>

							
						<div className='distributeStudentCodesGCModal-buttonContainer'>
							<Button disabled={!readyToSubmit} name='distributeStudentCodesSubmitBtn' submitLoading={this.state.submitLoading} label={`Send Links to ${studentCountLabel}`} size='xLarge' color={readyToSubmit? 'blue' : 'gray'} onClickFunction={this.shareStudentCodes}/>								
						
							<div onClick={this.handleClickCancel} className='distributeStudentCodesGCModal-buttonContainer-cancelBtn'>
								Not Now
							</div>
						</div>										
				</div>							
			</div>								
		)
		}
	}


class DistributeStudentCodesGCModalContainer extends Component {

	render() {
			return (
				<DistributeStudentCodesGCModal 
					section={this.props.section}
					dismissModal={this.props.dismissModal}
					user={this.props.user}
					showNotification={this.props.showNotification}
					onSendCodesSuccess={this.props.onSendCodesSuccess}
					sectionEmailStudentStudentCodes={this.props.sectionEmailStudentStudentCodes}
					upsertIntegration={this.props.upsertIntegration}
					sectionIntegrationRosterEmail={this.props.sectionIntegrationRosterEmail}
					syncSectionWithIntegration={this.props.syncSectionWithIntegration}
					isElearningActivationFlow={this.props.isElearningActivationFlow}
				/>)		
	}
}

export default connect(
	(state) => ({
		user:state.user
	}),
	{showNotification,sectionEmailStudentStudentCodes,upsertIntegration,syncSectionWithIntegration}
)(DistributeStudentCodesGCModalContainer)



